//@ts-ignore
import { CallbackFn, EventAttributes, ScreenEvent } from '@atlassiansox/analytics-web-client';
import GasAnalyticsClient from './gas-analytics-client';
import StubbedAnalyticsClient from './stubbed-analytics-client';
import { getEnvironment } from '@atlassian/temp-shared/environment';
import { LOCAL } from '@atlassian/temp-shared/environment-constants';

export const ANALYTICS_PRODUCT_DEFAULT = 'cssXp';
export const ANALYTICS_SUBPRODUCT_CASSI = 'cassi';
export const ANALYTICS_SUBPRODUCT_DEFAULT = ANALYTICS_SUBPRODUCT_CASSI;
export const ANALYTICS_SUBPRODUCT_ADV_CENTRAL = 'advocateCentral';
export const ANALYTICS_SUBPRODUCT_PARTNER_CENTRAL = 'partnerCentral';
export const ANALYTICS_PRODUCT_ECC = 'eccUi';
export const ANALYTICS_PRODUCT_SUBPRODUCT_ECC = 'eccUI';

export const initializeAnalyticsClient = (): AnalyticsClient => {
  if (getEnvironment() !== LOCAL) {
    return new GasAnalyticsClient();
  } else {
    return new StubbedAnalyticsClient();
  }
};

export interface AnalyticsOptions {
  subproduct?: string;
}

export interface AnalyticsClient {
  sendOperationalEvent(event: AnalyticsEvent, callback?: CallbackFn): Promise<void>;
  sendScreenEvent(event: ScreenEvent, callback?: CallbackFn): Promise<void>;
  sendTrackEvent(event: AnalyticsEvent, callback?: CallbackFn): Promise<void>;
  sendUIEvent(event: AnalyticsEvent, callback?: CallbackFn): Promise<void>;
  setSubproduct(subproduct: string): void;
  setAtlassianAccountId(aaid: string): void;
  setup(atlassianAccountIdProvider: AtlassianAccountIdProvider, options?: AnalyticsOptions): void;
  setupRoles(rolesProvider: RolesProvider): void;
  setGlobalPageProperties(properties: GlobalPageProperties): void;
  startUIViewedEvent(): void;
}

export interface AnalyticsEvent {
  source?: string;
  actionSubject?: string;
  action?: string;
  actionSubjectId?: string;
  attributes?: EventAttributes;
  tags?: string[];
}

export interface GlobalPageProperties {
  source: string;
  pageAttributes?: EventAttributes;
}

/**
 * Separates concerns around getting the Atlassian Account Id from the implementation of the analytics client
 */
export type AtlassianAccountIdProvider = () => Promise<string> | string;

export type RolesProvider = () => Promise<string[]> | string[];

export type GlobalPagePropertiesProvider = () => Promise<GlobalPageProperties>;

export const UNKNOWN_SCREEN = 'unknownScreen';
